import loadable from '@loadable/component';

export const EmbedSearchWidgetLayoutLoadable = loadable(
  () => import('./EmbedSearchWidgetLayout'),
);
